import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { UsuarioParametrizado } from "../Modelos/UsuarioParametrizado";

@Injectable({
    providedIn: 'root'
})
export class ParametrizacionService{

    constructor(){}

    async consultarUsuario(codigoUsuario: string=""): Promise<UsuarioParametrizado>{
        let url=new URL(`${environment.backendUrl}/api/Acceso/ConsultaUsuarioSoligespro`);
        let parameters={
            usuario: codigoUsuario
        };
        console.log("requestConsultaAgencia",codigoUsuario)
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
        let result=await (await fetch(url.toString(), {method: 'GET'})).json();
        console.log("requestConsultaAgencia",JSON.stringify(result))
        return UsuarioParametrizado.crearUsuario(
            result.vcLogin_usuario,
            result.vcNombre_usuario,
            result.vcMail_usuario,
            result.inCod_sucursal,
            result.vcNombre_sucursal,
            result.inCod_area,
            result.vcNombre_area,
            result.inCod_Cargo,
            result.vcDescrip_cargo,
            result.blExiste,
            new Date(result.sDFechaRegistro).toLocaleDateString("es-CO", {}),
            result.vcCod_usuarioSISE,
            result.inEstado
        );
    }

    async actualizarUsuarioSoligespro(usuario: UsuarioParametrizado){
        let entidad={
            "InCod_Aplicacion": environment.applicationId,
            "InCod_Sucursal": usuario.codigoSucursal,
            "InCod_Area": usuario.codigoArea,
            "InCod_Cargo": usuario.codigoCargo,
            "VcCod_usuario": usuario.login,
            "VcCod_usuarioSISE": usuario.codigoUsuarioSISE,
            "InEstado": (usuario.activo) ? -1 : 0,
            "SDFechaRegistro": usuario.fecha,
            "VcCod_usuario_modifica": "PROCAUTOMATICO"
        };

        let json=JSON.stringify(entidad);

        let request: RequestInit={
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json;charset=utf-8"
            },
            method: 'POST',
            body: json
        };
        let url=`${environment.backendUrl}/api/Acceso/ActualizarAccesoSoligespro`;
        console.log("requestActualizarAccesoSoligespro",json)
        let object=await (await fetch(url, request)).json();
        console.log("responseActualizarAccesoSoligespro",object)
        return object;
    }

    async crearUsuarioSoligespro(usuario: UsuarioParametrizado){
        let entidad={
            "InCod_Aplicacion": environment.applicationId,
            "InCod_Sucursal": usuario.codigoSucursal,
            "InCod_Area": usuario.codigoArea,
            "InCod_Cargo": usuario.codigoCargo,
            "VcCod_usuario": usuario.login,
            "VcCod_usuarioSISE": usuario.codigoUsuarioSISE,
            "InEstado": (usuario.activo)?-1:0,
            "SDFechaRegistro": usuario.fecha,
            "VcCod_usuario_modifica": "PROCAUTOMATICO"
        };

        let json=JSON.stringify(entidad);

        let request: RequestInit={
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json;charset=utf-8"
            },
            method: 'POST',
            body: json
        };
        let url=`${environment.backendUrl}/api/Acceso/CrearAccesoSoligespro`;
        let object=await (await fetch(url, request)).json();
        return object;
    }
}
